const fs = require("fs");

var VERSION = "version_not_found";
fs.readFile("../../../package.json", "utf8", (err, data) => {
  VERSION = JSON.parse(data).version;
});


import 'bootstrap';
import $ from 'jquery';
import bsCustomFileInput from 'bs-custom-file-input'

import './polyfills/closest';
import './polyfills/custom-events';

import Bulletins from './bulletins';
import Clearable from './clearable';
import DateTimePicker from './date-time-picker';
import Dropdown from './dropdowns';
import InputGroups from './input-groups';
import Modal from './modals';
import OptionGroups from './option-groups';
import Progress from './progress';
import Range from './ranges';
import Savebars from './savebars';
import SearchDropdown from './search-dropdowns';
import SearchListGroups from './search-list-groups';
import Sortable from './sortable';
import Tooltips from './tooltips';
import Toasts from './toasts';

// Any operations performed within `initialize` should be idempotent, i.e.
// the function is safe to run multiple times without changing the result.
// https://github.com/turbolinks/turbolinks#making-transformations-idempotent
const initialize = () => {
  bsCustomFileInput.init();
  Bulletins.attachAll();
  Clearable.attachAll();
  DateTimePicker.attachAll();
  SearchDropdown.attachAll();
  Sortable.attachAll();
  InputGroups.attachAll();
  Savebars.attachAll();
  OptionGroups.attachAll();
  Progress.attachAll();
  Range.attachAll();
  SearchListGroups.attachAll();
  Toasts.attachAll();
  Tooltips.attachAll();
}

document.addEventListener('turbolinks:load', initialize);
document.addEventListener('turbo:load', initialize);
window.addEventListener('DOMContentLoaded', initialize);

const podia = { VERSION: VERSION, $: $, modal: Modal, toasts: Toasts, dropdown: Dropdown, progress: Progress, sortable: Sortable }

window.podia = podia;

export default podia;
